import React from "react";
import * as palette from "@govlaunch/palette";
import { Field } from "react-final-form";
import { Filestack, Button } from "@govlaunch/core";
import ProfilePicture from "@govlaunch/profile-picture";
import { FormattedMessage } from "react-intl";

interface ILogoFieldProps {
  fieldName: string;
  entityName: string | null;
}

export default function LogoField({ fieldName, entityName }: ILogoFieldProps) {
  return (
    <Field name={fieldName}>
      {({ input }) => (
        <Filestack
          options={{
            accept: "image/*",
          }}
          onSuccess={({ filesUploaded }: any) => input.onChange(filesUploaded[0].url)}
          customRender={({ onPick }: any) => (
            <div>
              <div
                css={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <ProfilePicture xlarge={true} image={input.value} name={entityName || "A B"} />
              </div>

              <div
                css={{
                  display: entityName ? "flex" : "none",
                  justifyContent: "center",
                  marginTop: 10,
                  marginBottom: 10,
                  color: palette.darkGray,
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: 20,
                }}
              >
                {entityName}
              </div>

              <div
                css={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: 16,
                }}
              >
                <Button size="xsmall" color={palette.primary} onClick={onPick}>
                  <FormattedMessage defaultMessage="Upload" id="p4N05H" />
                </Button>

                {input.value && (
                  <span
                    css={{
                      marginLeft: 5,
                    }}
                  >
                    <Button
                      size="xsmall"
                      color={palette.red}
                      theme="secondary"
                      onClick={() => input.onChange(null as any)}
                    >
                      <FormattedMessage defaultMessage="Remove" id="G/yZLu" />
                    </Button>
                  </span>
                )}
              </div>
            </div>
          )}
        />
      )}
    </Field>
  );
}
